export default {
  init() {
    // JavaScript to be fired on all pages

    // Back to top pijltje, scroll naar boven
    if ($('#back-to-top').length) {
      var scrollTrigger = 100, // px
      backToTop = function () {
          var scrollTop = $(window).scrollTop();
          if (scrollTop > scrollTrigger) {
              $('#back-to-top').addClass('show');
          } else {
              $('#back-to-top').removeClass('show');
          }
      };
      backToTop();
      $(window).on('scroll', function () {
          backToTop();
      });
      $('#back-to-top').on('click', function (e) {
          e.preventDefault();
          $('html,body').animate({
              scrollTop: 0,
          }, 700);
      });
    }

    $('.membercount span').each(function () {
      $(this)
        .prop('Counter', 0)
        .animate(
          {
            Counter: $(this).text(),
          },
          {
            duration: 2500,
            easing: 'swing',
            step: function (now) {
              now = Number(Math.ceil(now)).toLocaleString('en');
              $(this).text(now);
            },
          }
        );
    });

    $( '.filter-link-members' ).on(
      'click',
      function ( e ) {
        e.preventDefault();
        $( 'aside.widget_block' ).toggleClass( 'showForm' );
        $( '.widget-meta-data-filter' ).toggleClass( 'showForm' );
        $( '.filter-link-members' ).toggleClass( 'hideForm-members' );
      }
    );

    $( '.hideForm-members' ).on(
      'click',
      function ( e ) {
        e.preventDefault();
        $( 'aside.widget_block' ).removeClass( 'showForm' );
        $( '.widget-meta-data-filter' ).removeClass( 'showForm' );
        $( '.filter-link-members' ).removeClass( 'hideForm-members' );
      }
    );
  
    if ($('.nav-top').length) {
      var menuscrollTrigger = 250, // px
      hideShowMenu = function () {
          var scrollTop = $(window).scrollTop();
          if (scrollTop > menuscrollTrigger) {
              $('.nav-top').addClass('hide');
              $('.brand').addClass('small');
              $('.site-header').addClass('collapsed');  
          } else {
              $('.nav-top').removeClass('hide');
              $('.brand').removeClass('small');
              $('.site-header').removeClass('collapsed');
          }
      };
      $(window).on('scroll', function () {
          hideShowMenu();
      });
    }

    var search = document.getElementById('search');

    $('#search-open').click( function(){
      search.classList.add('active');
      $ ('#search').attr('aria-expanded', true)
      $( '.search-field' ).focus();
    }),
    $('#search-close').click( function(){
      search.classList.remove('active');
    }),

    $(document).on('keyup', function(event) {
      if(event.key == 'Escape' && search.classList.contains('active')) {
        search.classList.remove('active');
      }
    });

    $( 'button.hamburger' ).click(function() {
      $( this ).toggleClass('is-active');
      $('.mobile-navigation-container').toggleClass('open');
      $('.mobile-navigation-container').removeClass('closed');

      $('.mobile-navigation-overlay').toggleClass('open');
      $('.mobile-navigation-overlay').removeClass('closed');
    });


    // accordion navigatie op mobiel
    // http://cssmenumaker.com/blog/wordpress-accordion-menu-tutorial/
    
    $('#cssmenu li.has-sub>a').on('click', function(){
      // var href = $(this).attr('href'); 
      // $(this). attr('data-href', href);
      $(this).removeAttr('href');
      $(this).children('.link_text').prepend('<a>');

      var element = $(this).parent('li');
      if (element.hasClass('open')) {
        // var dataHref = $(this).attr('data-href'); 
        // $(this). attr('href', dataHref);
        element.removeClass('open');
        element.find('li').removeClass('open');
        element.find('ul').slideUp();
      }
      else {
        element.addClass('open');
        element.children('ul').slideDown();
        element.siblings('li').children('ul').slideUp();
        element.siblings('li').removeClass('open');
        element.siblings('li').find('li').removeClass('open');
        element.siblings('li').find('ul').slideUp();
      }
      //$(this). attr('href', href);
    });
  
    $('#cssmenu>ul>li.has-sub>a').append('<span class="holder"></span>');  

    // nog een keer voor de Footer:
    $('#mobilefootermenu li.has-sub>a').on('click', function(){
      // var href = $(this).attr('href'); 
      // $(this). attr('data-href', href);
      $(this).removeAttr('href');
      $(this).children('.link_text').prepend('<a>');

      var element = $(this).parent('li');
      if (element.hasClass('open')) {
        // var dataHref = $(this).attr('data-href'); 
        // $(this). attr('href', dataHref);
        element.removeClass('open');
        element.find('li').removeClass('open');
        element.find('ul').slideUp();
      }
      else {
        element.addClass('open');
        element.children('ul').slideDown();
        element.siblings('li').children('ul').slideUp();
        element.siblings('li').removeClass('open');
        element.siblings('li').find('li').removeClass('open');
        element.siblings('li').find('ul').slideUp();
      }
      //$(this). attr('href', href);
    });
  
    $('#mobilefootermenu>ul>li.has-sub>a').append('<span class="holder"></span>');

    if (document.getElementById('schakel-filter')) {
			document.getElementById('schakel-filter').addEventListener('click', e => {
				e.preventDefault();
				document.querySelector('.filter-col').classList.toggle('open');
        document.querySelector('.filterMobile').classList.toggle('hideBtn');
			});
		}

    if (document.getElementById('schakel-filter-hide')) {
			document.getElementById('schakel-filter-hide').addEventListener('click', e => {
				e.preventDefault();
				document.querySelector('.filter-col').classList.remove('open');
        document.querySelector('.filterMobile').classList.remove('hideBtn');
			});
		}
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
